var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass()},[_c('i',{staticClass:"fal fa-spinner-third fa-spin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }